import type { ProdutoCatalogo } from "@/api"
import type { RootState } from "@/store"
import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import CardProduto from "@/components/catalogo-kiosk/card-produto"
import { temPassos } from "@/components/catalogo-kiosk/passos"
import { adicionarProdutoSimples, atualizarKiosk, removerProdutoSimples } from "@/store/self-service-kiosk-slice"

interface CardCheckoutProps {
    produto: ProdutoCatalogo
    cor: string | null
    /** O ⓘ do cartão abre o detalhe do produto. */
    aoAbrirDetalhes?: (produto: ProdutoCatalogo) => void
}

/** Card da grade do totem checkout: quantidade e ações vêm do carrinho do kiosk. */
function CardCheckout({ produto, cor, aoAbrirDetalhes }: CardCheckoutProps): JSX.Element {
    const dispatch = useDispatch()
    const quantidade = useSelector((state: RootState) =>
        state.selfServiceKiosk.cartItems.reduce(
            (soma, item) => (item.idProduto === produto.id ? soma + item.quantidade : soma),
            0,
        ),
    )

    const adicionar = useCallback(() => {
        if (temPassos(produto)) {
            dispatch(atualizarKiosk({ stepDialogProduct: produto }))
            return
        }

        dispatch(adicionarProdutoSimples({
            idProduto: produto.id,
            nome: produto.descricao,
            valorUnitario: produto.valor,
            faixasPreco: produto.faixasPreco,
        }))
    }, [produto, dispatch])

    const remover = useCallback(() => {
        dispatch(removerProdutoSimples(produto.id))
    }, [produto.id, dispatch])

    return (
        <CardProduto
            produto={produto}
            cor={cor}
            quantidade={quantidade}
            onAdicionar={adicionar}
            onRemover={remover}
            onAbrirDetalhes={aoAbrirDetalhes}
        />
    )
}

export default CardCheckout
